/**
 * BOTTOM GENERAL INITS
 * Place here general and "must be" faster inits
 * Place this file at the end of document
 */


/**
 * ---------------------------------------------------------------
 * APP Flags
 * ---------------------------------------------------------------
 */

// Debug
app.DEBUG = false;


/**
 * ---------------------------------------------------------------
 * STATIC CONSTRUCTS
 * Selectors lookups
 * ---------------------------------------------------------------
 */

// register selectors lookups
app.objMap = {
	//slidersHighlights:  '[class^="md-slider-highlights"]:not(.col-right)',
	//slidersHighlightsR: '[class^="md-slider-highlights"].col-right',
	//slidersMagazine:    '.md-slider-magazine',
	//slidersMagazine2:   '.md-slider-magazine--type2',
	sliderBreadcrumbs:  '.md-slider-breadcrumbs',
	sliderInner:        '.md-slider-inner',
	boxTextMore:        '#box-text-more',
	btnCourseSuscr:     '.btn-course-suscr',
	slidersTable:       '.md-slider-table',
	sliderTicker:       '.md-ticker',
	sliderTabs:         '.md-slider-tabs',
	// telInputValidate:	'input[type="tel"]'
};


/**
 * ---------------------------------------------------------------
 * Self Init Stuff Map (procedural)
 * ---------------------------------------------------------------
 * [app.inits]||[init](initMap, [ {NS: ["nsp", "aux"]} ]);
 */

// INITS MAIN
app.inits.main = (function(init) {

	// init map
	var initMap = function(arg) {

		// var $lazyImages = app.images.init();

    	// INIT SLIDER
		/*if ( app.$jObjMap['slidersHighlights'].length ) {
			app.sliderHighlights.init(app.$jObjMap['slidersHighlights']);

			app.sliderHighlights.swipers.forEach(function(swiper) {
        	$lazyImages.filter(function() {
					return swiper.container.length;
				}).trigger("unveil");
      		});
    	}

		if ( app.$jObjMap['slidersHighlightsR'].length ) {
			app.sliderHighlightsR.init(app.$jObjMap['slidersHighlightsR']);
    	}*/

		/*if ( app.$jObjMap['slidersMagazine'].length ) {
			app.slidersMagazine.init(app.$jObjMap['slidersMagazine']);
			app.slidersMagazine.swipers.forEach(function(swiper) {
        	$lazyImages.filter(function() {
					return swiper.container.length;
				}).trigger("unveil");
      		});
    	}

		if ( app.$jObjMap['slidersMagazine2'].length ) {
			app.slidersMagazine2.init(app.$jObjMap['slidersMagazine2']);
			app.slidersMagazine2.swipers.forEach(function(swiper) {
        	$lazyImages.filter(function() {
					return swiper.container.length;
				}).trigger("unveil");
      		});
    	}*/

		/*if ( app.$jObjMap['sliderBreadcrumbs'].length ) {
			app.sliderBreadcrumbs.init(app.$jObjMap['sliderBreadcrumbs']);
    	}

		if ( app.$jObjMap['sliderTicker'].length ) {
			app.sliderTicker.init(app.$jObjMap['sliderTicker']);
    	}

		if ( app.$jObjMap['sliderInner'].length ) {
			app.sliderInner.init(app.$jObjMap['sliderInner']);
		}

		if ( app.$jObjMap['slidersTable'].length ) {
			app.slidersTable.init(app.$jObjMap['slidersTable']);
		}

		if ( app.$jObjMap['sliderTabs'].length ) {
			app.sliderTabs.init(app.$jObjMap['sliderTabs']);
		}*/

		if ( app.$jObjMap['boxTextMore'].length ) {
			app.boxTextMore.init(app.$jObjMap['boxTextMore']);
		}

		if ( app.$jObjMap['btnCourseSuscr'].length ) {
			app.btnCourseSuscr.init(app.$jObjMap['btnCourseSuscr']);
		}

		// if ( app.$jObjMap['telInputValidate'].length ) {
		// 	app.telInputValidate.init(app.$jObjMap['telInput']);
		// }

	};

	// IIFE init
	init(initMap);

	// return a callable fn
	return function () {
		// init(initMap, {NS: ["nsp", "aux"]);
		init(initMap);
	};

}(app.inits));


// INITS: REFRESHABLES (ajax contents...)
app.inits.refreshables = (function(init) {
	// init map
	var initMap = function(arg) {
		// app.foo.init();
	};

	// first exec
	init(initMap);

	// return a callable fn
	return function() {
		// init(initMap, {NS: ["nsp", "aux"]);
		init(initMap);
	};
}(app.inits));



/* EOF */
